export const updateProfile = (creds) => {
  // const alertify = require("alertifyjs")
  // TODOs redux yapısı bozuldu. Düzelt (Update_Profile)
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    const user = firebase.auth().currentUser;
    const authorId = getState().firebase.auth.uid;
    const firestore = getFirebase().firestore();
    const alertify = require("alertifyjs");

    firestore
      .collection("profile")
      .doc(authorId)
      .set(
        {
          authority: creds.authority,
          officeNo: creds.officeNo,
          personalNo: creds.personalNo,
          strAdd: creds.strAdd,
          strAdd2: creds.strAdd2,
          city: creds.city,
          stateProvince: creds.stateProvince,
          postalZip: creds.postalZip,
          country: creds.country,
          authorId: authorId,
          createdAt: new Date(),
        },
        { merge: true }
      )
      .then(() => {
        user
          .updateProfile({
            displayName: user.displayName,
          })
          .then(() => {
            alertify.success("Update Successfull");
          })
          .then(() => {
            window.location.reload();
          })
          .catch((err) => {
            dispatch({ type: "UPDATE_PROFILE_ERR" }, err);
          });
      })
      .catch((err) => {
        dispatch({ type: "UPDATE_PROFILE_ERR" }, err);
      });
  };
};

// export const updateProfileModal = (creds) => {
//   const alertify = require("alertifyjs");
//   // TODOs redux yapısı bozuldu. Düzelt (Update_Profile)
//   return (dispatch, getState, { getFirebase }) => {
//     // const firebase = getFirebase();
//     // const user = firebase.auth().currentUser;
//     const authorId = getState().firebase.auth.uid;
//     const firestore = getFirebase().firestore();


//     // console.log("Update Profile Modal:", state);
//     firestore
//       .collection("profile")
//       .doc(authorId)
//       .set(
//         {
//           ...creds,
//           // authorId: authorId,
//           date: new Date(),
//         },
//         { merge: true }
//       )
//       .then(() => {
//         alertify.success("Update Successful");
//       })
//       .catch((err) => {
//         dispatch({ type: "UPDATE_PROFILE_ERR" }, err);
//       });
//   };
// };

export const addTask = (task) => {
  return (dispatch, getState, { getFirebase }) => {
    const firestore = getFirebase().firestore();
    const authorId = getState().firebase.auth.uid;

    firestore
      .collection("tasks")
      .add({
        ...task,
        authorId: authorId,
        date: new Date(),
      })
      .then(() => {
        dispatch({
          type: "ADD_TASK",
          task,
        });
      })
      .catch((err) => {
        dispatch({
          type: "ADD_TASK_ERR",
          err,
        });
      });
  };
};

export const removeTask = (task) => {
  return (dispatch, getState, { getFirebase }) => {
    const firestore = getFirebase().firestore();
    firestore
      .collection("tasks")
      .doc(task.id)
      .delete()
      .then(() => {
        dispatch({
          type: "REMOVE_TASK",
        });
      })
      .catch((err) => {
        dispatch({
          type: "REMOVE_TASK_ERR",
          err,
        });
      });
  };
};

export const toggleChecked = (task) => {
  return (dispatch, getState, { getFirebase }) => {
    const firestore = getFirebase().firestore();

    firestore
      .collection("tasks")
      .doc(task.id)
      .set(
        {
          ...task,
          checked: !task.checked,
        },
        { merge: true }
      )
      .then(() => {
        dispatch({
          type: "TOGGLE_CHECKED",
          task,
        });
      })
      .catch((err) => {
        dispatch({
          type: "TOGGLE_CHECKED_ERR",
          err,
        });
      });
  };
};
